export const DOMAINS: any = [
  {
    id: 'NG',
    hostname: 'beta-business.travelstart.com',
    b2b_iframe_Link: 'https://beta.travelstart.com.ng/',
    TS_ORG: 'TS_NG',
    env: 'beta',
    ts_Country: 'NG',
    currency: 'NGN',
  },
  {
    id: 'NG',
    hostname: 'business.travelstart.com',
    b2b_iframe_Link: 'https://www.travelstart.com.ng/',
    TS_ORG: 'TS_NG',
    env: 'live',
    ts_Country: 'NG',
    currency: 'NGN',
  },
  {
    id: 'NG',
    hostname: 'beta-travelstart-ng.myota.travel',
    b2b_iframe_Link: 'https://beta.travelstart.com.ng/',
    TS_ORG: 'TS_NG',
    env: 'beta',
    ts_Country: 'NG',
    currency: 'NGN',
  },
  {
    id: 'ZA',
    hostname: 'beta-travelstart-za.myota.travel',
    b2b_iframe_Link: 'https://beta.travelstart.co.za/',
    TS_ORG: 'TS_ZA',
    env: 'beta',
    ts_Country: 'ZA',
    currency: 'ZAR',
  },
  {
    id: 'FS',
    hostname: 'beta-flightsite.myota.travel',
    b2b_iframe_Link: 'https://beta.travelstart.co.za/',
    TS_ORG: 'TS_FS',
    env: 'beta',
    ts_Country: 'ZA',
    currency: 'ZAR',
  },
  {
    id: 'CT',
    hostname: 'beta-clubtravel.myota.travel',
    b2b_iframe_Link: 'https://beta.travelstart.co.za/',
    TS_ORG: 'TS_CT',
    env: 'beta',
    ts_Country: 'ZA',
    currency: 'ZAR',
  },
  {
    id: 'NG',
    hostname: 'travelstart-ng.myota.travel',
    b2b_iframe_Link: 'https://www.travelstart.com.ng/',
    TS_ORG: 'TS_NG',
    env: 'live',
    ts_Country: 'NG',
    currency: 'NGN',
  },
  {
    id: 'ZA',
    hostname: 'travelstart-za.myota.travel',
    b2b_iframe_Link: 'https://www.travelstart.co.za/',
    TS_ORG: 'TS_ZA',
    env: 'live',
    ts_Country: 'ZA',
    currency: 'ZAR',
  },
  {
    id: 'FS',
    hostname: 'flightsite.myota.travel',
    b2b_iframe_Link: 'https://www.travelstart.co.za/',
    TS_ORG: 'TS_FS',
    env: 'live',
    ts_Country: 'ZA',
    currency: 'ZAR',
  },
  {
    id: 'FS',
    hostname: 'preprod-flightsite.myota.travel',
    b2b_iframe_Link: 'https://preprod.travelstart.co.za/',
    TS_ORG: 'TS_FS',
    env: 'preprod',
    ts_Country: 'ZA',
    currency: 'ZAR',
  },
  {
    id: 'CT',
    hostname: 'preprod-clubtravel.myota.travel',
    b2b_iframe_Link: 'https://preprod.travelstart.co.za/',
    TS_ORG: 'TS_CT',
    env: 'preprod',
    ts_Country: 'ZA',
    currency: 'ZAR',
  },
  {
    id: 'TS',
    hostname: 'preprod-travelstart-ng.myota.travel',
    b2b_iframe_Link: 'https://preprod.travelstart.com.ng/',
    TS_ORG: 'TS_NG',
    env: 'preprod',
    ts_Country: 'NG',
    currency: 'NGN',
  },
  {
    id: 'TS',
    hostname: 'preprod-travelstart-za.myota.travel',
    b2b_iframe_Link: 'https://preprod.travelstart.co.za/',
    TS_ORG: 'TS_ZA',
    env: 'preprod',
    ts_Country: 'ZA',
    currency: 'ZAR',
  },
  {
    id: 'CT',
    hostname: 'clubtravel.myota.travel',
    b2b_iframe_Link: 'https://www.travelstart.co.za/',
    TS_ORG: 'TS_CT',
    env: 'live',
    ts_Country: 'ZA',
    currency: 'ZAR',
  },
  {
    id: 'NG',
    hostname: 'preprod-business.travelstart.com',
    b2b_iframe_Link: 'https://preprod.travelstart.com.ng/',
    TS_ORG: 'TS_NG',
    env: 'preprod',
    ts_Country: 'NG',
    currency: 'NGN',
  },
  {
    id: 'NG',
    hostname: 'localhost',
    b2b_iframe_Link: 'http://localhost:6200/',
    TS_ORG: 'TS_NG',
    env: 'preprod',
    ts_Country: 'ZA',
    currency: 'ZAR',
  },
];

type DomainConfig = {
  id: string;
  hostname: string;
  b2b_iframe_Link: string;
  TS_ORG: string;
  env: string;
  ts_Country: string;
  currency: string;
};

type PreviewDomainPrefix = 'ng' | 'za' | 'fs' | 'ct';

const BETA_NG_DOMAIN = DOMAINS.find(
  (domain: DomainConfig) => domain.hostname === 'beta-business.travelstart.com'
) as DomainConfig;
const BETA_ZA_DOMAIN = DOMAINS.find(
  (domain: DomainConfig) => domain.hostname === 'beta-travelstart-za.myota.travel'
) as DomainConfig;
const BETA_FS_DOMAIN = DOMAINS.find(
  (domain: DomainConfig) => domain.hostname === 'beta-flightsite.myota.travel'
) as DomainConfig;
const BETA_CT_DOMAIN = DOMAINS.find(
  (domain: DomainConfig) => domain.hostname === 'beta-clubtravel.myota.travel'
) as DomainConfig;

const PREVIEW_DOMAINS_BY_PREFIX: Record<PreviewDomainPrefix, DomainConfig> = {
  ng: BETA_NG_DOMAIN,
  za: BETA_ZA_DOMAIN,
  fs: BETA_FS_DOMAIN,
  ct: BETA_CT_DOMAIN,
};

export function findDomainByHostname(hostname: string): DomainConfig | undefined {
  const exactDomain = DOMAINS.find((domain: DomainConfig) => domain.hostname === hostname) as DomainConfig;

  if (exactDomain) {
    return exactDomain;
  }

  const previewMatch = hostname.match(/^beta-preview-b2b-(ng|za|fs|ct)-[a-z0-9-]{1,43}\.travelstart\.com$/);

  if (!previewMatch) {
    return undefined;
  }

  const previewPrefix = previewMatch[1] as PreviewDomainPrefix;
  const previewDomain = PREVIEW_DOMAINS_BY_PREFIX[previewPrefix] || BETA_NG_DOMAIN;

  if (!previewDomain) {
    return undefined;
  }

  return {
    ...previewDomain,
    hostname,
    env: 'beta',
  };
}
